import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {extractGtin14FromBarcode} from '../helpers/gs1Barcode';


export async function fetchProductsForGrid({
  skip = 0,
  limit = 50,
  sortInfo = null,
  searchQuery = '',
  filter = 'active',
  is_kit = -1
} = {}) {
  try {
    const access_token = await AsyncStorage.getItem('access_token');
    const baseUrl = await AsyncStorage.getItem('url');

    const gtin14 = extractGtin14FromBarcode(searchQuery);
    const trimmedSearch = (gtin14 || searchQuery)?.trim() || '';
    const isSearching = trimmedSearch.length > 0;

    // Determine endpoint and params based on whether we're searching
    let url = isSearching ? `${baseUrl}/products/search.json` : `${baseUrl}/products.json`;
    let params = {
      sort: sortInfo?.name || '',
      order: sortInfo?.dir === 1 ? 'ASC' : 'DESC',
      limit,
      offset: skip,
      is_kit
    };

    // Add search-specific params
    if (isSearching) {
      params.search = trimmedSearch;
      params.advanced_search = false;
      if (filter && filter !== 'all') {
        params.filter = filter;
      }
    } else {
      params.filter = filter;
    }

    const response = await axios({
      method: 'get',
      url,
      params,
      headers: {
        Authorization: `Bearer ${access_token}`
      }
    });

    const productsCount = response.data.products_count || {};
    let totalCount = 0;

    if (isSearching) {
      totalCount = productsCount.search || productsCount.all || response.data.products?.length || 0;
    } else {
      totalCount = productsCount[filter] || productsCount.all || response.data.products?.length || 0;
    }

    return {
      data: response.data.products || [],
      count: totalCount
    };
  } catch (error) {
    console.error('fetchProductsForGrid error:', error);
    return { data: [], count: 0 };
  }
}

